<template>
  <div
    class="fixed bottom-20 md:bottom-10 right-0 flex items-stretch transition-200 z-[999999]"
    :class="[!trigger ? checkLocale : '']"
  >
    <div
      @click="toggle"
      class="flex-y-center cursor-pointer justify-end bg-green rounded-l-[32px] mt-[9px] h-[54px] w-[49px] pr-[9px] hover:bg-green-600 transition-200"
    >
      <div class="w-6 h-6 flex-center" v-if="!trigger">
        <i class="icon-messages text-white text-2xl" />
      </div>
      <div
        class="w-6 h-6 flex-center bg-white rounded-full p-1 transition-200"
        v-else
      >
        <span class="icon-close text-green text-base"></span>
      </div>
    </div>
    <div class="!bg-white p-2 shadow-dropdown rounded-lg">
      <p class="text-xs text-gray-450">{{ $t("contact") }}</p>
      <a
        href="https://t.me/sarafrobotcommunity"
        target="_blank"
        class="w-full bg-gray-250 rounded-md p-2 space-x-1 flex-y-center justify-start mt-1 group hover:bg-green-100"
      >
        <i
          class="icon-telegram text-xl text-gray-450 leading-[20px] group-hover:text-green"
        ></i>
        <span class="text-xs text-gray-450 group-hover:text-green">
          {{ $t("join_to_telegram") }}
        </span>
      </a>
      <a
        href="https://t.me/sarafrobot_support"
        target="_blank"
        class="w-full bg-gray-250 rounded-md p-2 space-x-1 flex-y-center justify-start mt-1 group hover:bg-green-100"
      >
        <i
          class="icon-message-question text-xl text-gray-450 leading-[20px] group-hover:text-green"
        ></i>
        <span class="text-xs text-gray-450 group-hover:text-green">
          {{ $t("saraf_support") }}
        </span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();

const trigger = ref(false);

function toggle() {
  trigger.value = !trigger.value;
}

const checkLocale = computed(() => {
  return locale.value === "en"
    ? "translate-x-[183px]"
    : locale.value === "uz"
      ? "translate-x-[195px]"
      : "translate-x-[296px]";
});
</script>

<style scoped></style>
